
<div class="page-content" page-content>
  @if (showTimeoutMessage) {
    <div class="TimerNotificationContainer">
      <img class="alertImage" src="assets/alert.svg" alt="alert"/>
      <prism-ui-copy
        key-id="session-timeout-message"
        >
        <div>For your security, your session timed out due to inactivity.</div>
      </prism-ui-copy>
    </div>
    <br>
    }

    @if (!evidenceRequired || ceoiPolicyFlag) {
      <img class="centerImage" alt="sick-computer-" src="{{alertLogoUrl}}"/>
      <br>
        @if (ceoiPolicyFlag) {
          <div>
            <prism-ui-heading
              slot="instructions-ceoi-header"
              key-id="instructions-ceoi-header"
              font-size="lg"
              font-weight="regular"
              is-uppercase="false"
              variant="default"
              >
              {{ceoiPolicyFlagContent.title}}
            </prism-ui-heading>
            <prism-ui-copy
              key-id="instructions-ceoi-body"
              >
              <p class="center">{{ceoiPolicyFlagBody}}</p>
            </prism-ui-copy>
          </div>
        }
        @if (!evidenceRequired) {
          <div>
            <prism-ui-heading
              slot="instructions-no-evidence-header"
              key-id="instructions-no-evidence-header"
              font-size="lg"
              font-weight="regular"
              is-uppercase="false"
              variant="default"
              >
              {{evidenceContent.title}}
            </prism-ui-heading>
            <prism-ui-copy
              key-id="instructions-no-evidence-body"
              >
              <p class="center">{{noEvidenceRequiredText}}</p>
            </prism-ui-copy>
          </div>
        }
      }

      @if (evidenceRequired && !ceoiPolicyFlag) {
        <prism-ui-grid-container>
          <prism-ui-grid variant="unequal" left-column-width="6" key-id="instructions-banner-grid">
            <div>
              <prism-ui-heading
                slot="instructions-header"
                key-id="instructions-header"
                font-size="xl"
                font-weight="regular"
                is-uppercase="false"
                variant="default"
                >
                {{instructionsContent.title}}
              </prism-ui-heading>
              <br>
                <app-maintenance-notification ></app-maintenance-notification>
                <prism-ui-copy
                  key-id="instructions-body"
                  >
                  <p [innerHTML]="instructionsContent.body"></p>
                </prism-ui-copy>
              </div>
              <div>
                <img src="assets/illustrations/checklist-progress-2.svg" alt="checklist-progress" width="100%"/>
              </div>
            </prism-ui-grid>
          </prism-ui-grid-container>
        }
        <div class="instructions-container">
          <prism-ui-container
            is-compact="false"
            key-id="instructions-container"
            has-shadow="false"
            variant="default"
            has-no-border-radius="false"
            >
            <div class="">
              <div class="gather-content-header">
                <prism-ui-heading
                  slot="gather-content-header"
                  key-id="gather-content-header"
                  font-size="sm"
                  font-weight="strong"
                  is-uppercase="false"
                  variant="default"
                  >
                  {{gatherContent.title}}
                </prism-ui-heading>
                <prism-ui-copy
                  key-id="gather-content-body"
                  >
                  <prism-ui-grid-container>
                    @if (!hasPolicyId && !isCustumUrl) {
                      <prism-ui-grid breakpoint="300" key-id="gatherContent-digit-policy-grid">
                        <div>
                          <img src="assets/stylized-icons/clipboard.svg" alt="clipboard"/>
                        </div>
                        <div>
                          <strong>{{gatherContentDigitPolicy.title}}</strong>
                          <p [innerHTML]="gatherContentDigitPolicy.body"></p>
                        </div>
                      </prism-ui-grid>
                    }
                    <prism-ui-grid breakpoint="300" key-id="gatherContent-coverage-grid">
                      <div>
                        <img src="assets/stylized-icons/umbrella-heart.svg" alt="umbrella-heart"/>
                      </div>
                      <div>
                        <strong>{{gatherContentCoverage.title}}</strong>
                        <p [innerHTML]="gatherContentCoverage.body"></p>
                      </div>
                    </prism-ui-grid>
                    <prism-ui-grid breakpoint="300" key-id="gatherContent-medical-grid">
                      <div>
                        <img src="assets/stylized-icons/medical-claim.svg" alt="medical-claim"/>
                      </div>
                      <div>
                        <strong>{{gatherContentMedical.title}}</strong>
                        <p [innerHTML]="gatherContentMedical.body"></p>
                      </div>
                    </prism-ui-grid>
                  </prism-ui-grid-container>
                </prism-ui-copy>
              </div>
            </div>

          </prism-ui-container>
          <div class="instructions-session-container">
            <prism-ui-container
              is-compact="false"
              key-id="instructions-session-container"
              has-shadow="false"
              variant="default"
              has-no-border-radius="false"
              >
              <prism-ui-heading
                key-id="gather-content-header"
                font-size="xs"
                font-weight="strong"
                is-uppercase="false"
                variant="default"
                >
                {{sessionContent.title}}
              </prism-ui-heading>
              <prism-ui-copy
                key-id="session-content-body"
                >
                <div [innerHTML]="sessionContent.body"></div>
              </prism-ui-copy>
            </prism-ui-container>
          </div>
          <prism-ui-button class="center continueCancelButtonPadding"
            button-width="content"
            key-id="start-button"
            size="md"
            variant="primary"
            type="submit"
            is-icon-right-aligned="false"
            is-waiting="false"
            (click)="onSubmit()"
          >Start the Statement</prism-ui-button>
        </div>
         @if (isApiResponse) {
       
  <div class="page-loader">
        <prism-ui-loader
          has-logo="false"
          is-reverse="false"
          key-id="page-loader"
          size="md"
          >
        </prism-ui-loader>
        <prism-ui-copy
          font-size="md"
          font-style="normal"
          font-weight="regular"
          key-id="spinner-loading-text"
          line-height="medium"
          text-decoration="none"
          variant="default"
          >
          <span>{{pageLoaderElement?.label}}</span>
        </prism-ui-copy>
      </div>
    }
      </div>


